<template>
  <div class="vertical-navigation">
    <div class="vertical-navigation__navigation-vertical-steps">
      <b-link
        v-for="(header, index) in steps"
        :key="index"
        :disabled="!canGoToStepByHeader(index)"
        @click="goToStep(index)">
        <div
          class="vertical-navigation__vertical-step"
          :class="stepClass(index)">
            <div class="vertical-navigation__vertical-step-badge-container">
              <b-badge
                class="vertical-navigation__vertical-step-badge"
                :class="pillClass(index)"
                pill
                :variant="pillVariant(index)">
                {{index+1}}
              </b-badge>
            </div>
            <div class="vertical-navigation__vertical-step-info">
              <span class="vertical-navigation__vertical-step-title">
                {{ getHeaderLabel(header) }}
              </span>
              <p class="vertical-navigation__vertical-step-detail">
                {{ getHeaderDetail(header) }}
              </p>
            </div>
        </div>
      </b-link>
    </div>
    <h3 class="vertical-navigation__mobile-active-step-title">
      {{ activeStepTitle }}
    </h3>
    <p class="vertical-navigation__mobile-active-step-detail">
      {{ activeStepDetail }}
    </p>
  </div>
</template>
<script>
import NavigationMixin from '../mixins/navigationMixin';
import HeaderNavigationMixin from '../mixins/headerNavigationMixin';

export default {
  name: 'VerticalNavigation',
  mixins: [NavigationMixin, HeaderNavigationMixin],
  computed: {
    activeStepTitle() {
      return this.getHeaderLabel(this.steps[this.step]);
    },
    activeStepDetail() {
      return this.getHeaderDetail(this.steps[this.step]);
    },
  },
  methods: {
    pillVariant(index) {
      return index <= this.step ? 'secondary' : 'light';
    },
    pillClass(index) {
      return index <= this.step ? '' : 'vertical-navigation__vertical-step-badge_not-active';
    },
  },
};
</script>
<style lang="sass" scoped>
@import src/styles/defaults/variables
@import "src/styles/defaults/mobile-first"

.vertical-navigation
  padding: 15px 10px
  &__navigation-vertical-steps
    border-top: 1px solid #ccc
    justify-content: space-between
    display: flex
    height: 100%
  &__vertical-step
    display: flex
    cursor: pointer
    &:not(.active-step),
    &:not(.visited-step)
      opacity: .65
    &.active-step,
    &.visited-step
      color: $color-secondary
      font-weight: bold
      opacity: 1
  &__vertical-step-info
    display: flex
    flex-direction: column
  &__vertical-step-title
    display: none
  &__vertical-step-detail
    display: none
    font-size: 0.9em
    font-weight: normal
  &__vertical-step-badge-container
    position: relative
    margin-top: -12px
    > *
      padding: 4px 6px
  &__vertical-step-badge
    &_not-active
      background-color: var(--vertical-step-pill-not-active-background)
  &__mobile-active-step-title
    padding: 10px 0
    font-weight: bold
  &__mobile-active-step-detail
    font-size: 0.9em
    margin-bottom: 0
  &__mobile-active-step-title,
  &__mobile-active-step-detail
    text-align: center
    color: $color-secondary
  +media-min-lg()
    &__vertical-step-title
      display: inline
    &__navigation-vertical-steps
      border-top: 0
      border-left: 1px solid #ccc
      padding-left: 15px
      flex-direction: column
    &__vertical-step-badge-container
      margin-right: 15px
      margin-left: -25px
      margin-top: 0
    &__mobile-active-step-title,
    &__mobile-active-step-detail
      display: none
  +media-min-lg()
    max-width: 300px
    padding: 40px 25px
    &__vertical-step-detail
      display: inline
</style>
